import React, { PropsWithoutRef, ReactElement, type JSX } from 'react';

import { useTranslation } from 'react-i18next';
import { Button, Grid2, Stack, Typography } from '@mui/material';

type ModelHeaderProps = {
  title: string | JSX.Element;
  cancelButtonText?: string;
  handleClose: () => void;
  confirmButton?: ReactElement;
  secondaryActionButton?: ReactElement | null;
};

const ModelHeaderWithSubmit = ({
  title,
  handleClose,
  cancelButtonText,
  confirmButton,
  secondaryActionButton,
}: PropsWithoutRef<ModelHeaderProps>) => {
  const { t } = useTranslation('common');
  return (
    <Grid2 container sx={{ justifyContent: 'space-between' }}>
      <Grid2>
        <Button onClick={handleClose}>
          {cancelButtonText ?? t('common.cancel', 'Cancel')}
        </Button>
      </Grid2>
      <Grid2>
        {typeof title === 'string' ? (
          <Typography variant="h6">{title}</Typography>
        ) : (
          title
        )}
      </Grid2>
      <Stack direction="row" spacing={1}>
        <Grid2>{secondaryActionButton}</Grid2>
        <Grid2>{confirmButton}</Grid2>
      </Stack>
    </Grid2>
  );
};

export default ModelHeaderWithSubmit;
